import {
	IDependencyOptionsParams,
	TCommonValueField,
	TDependenciesImport,
	TSelectedField,
} from '@interfaces/import/import';

function getDependencyCurrentFieldsWithoutOptions<T extends TCommonValueField | TSelectedField>({
	currentField,
	defaultValue,
}: IDependencyOptionsParams<T>): TDependenciesImport {
	return currentField.dependencies
		?.filter(dependency => defaultValue && dependency.dependencyValues
			?.map(dependency => dependency.selectedValue).includes(defaultValue))
		?.filter(dependency => !dependency.dependencyValues[0].options) || [];
}

function getDependencyFieldsWithoutOptions<T extends TCommonValueField | TSelectedField>({
	currentField,
	defaultValue,
}: IDependencyOptionsParams<T>): TDependenciesImport {
	return currentField.dependencies
		?.filter(dependency => !defaultValue || !dependency.dependencyValues
			?.map(dependency => dependency.selectedValue).includes(defaultValue))
		?.filter(dependency => !dependency.dependencyValues[0].options) || [];
}

export {
	getDependencyCurrentFieldsWithoutOptions,
	getDependencyFieldsWithoutOptions,
};
